import React, { useEffect } from "react";
import { faqs } from "../data/faqs";
import { business } from "../data/site";
const title = "Rinnai Air Conditioning Perth | Free Home Quote";
const description = "Rinnai air conditioning specialists serving Perth homes. Compare ducted, split and multi-split options and request a free, no-obligation home quote.";
const structuredData = {
  "@context": "https://schema.org",
  "@graph": [{
    "@type": "HVACBusiness",
    name: business.name,
    url: business.url,
    telephone: "+61 8 9228 3555",
    areaServed: {
      "@type": "City",
      name: "Perth"
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "Perth",
      addressRegion: "WA",
      addressCountry: "AU"
    },
    makesOffer: [{
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Rinnai ducted air conditioning supply and installation"
      }
    }, {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Rinnai split system air conditioning supply and installation"
      }
    }, {
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: "Rinnai multi-split air conditioning supply and installation"
      }
    }]
  }, {
    "@type": "FAQPage",
    mainEntity: faqs.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  }]
};
export function Seo() {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = "en-AU";
    let descriptionElement = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!descriptionElement) {
      descriptionElement = document.createElement("meta");
      descriptionElement.name = "description";
      document.head.appendChild(descriptionElement);
    }
    descriptionElement.content = description;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.seo = "phac-local-business";
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return null;
}